<template>
  <svg
    class="c-icon c-icon--blue"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    height="28"
    width="28"
    viewBox="0 0 28 28"
  >
    <use :xlink:href="'/assets/img/sprite.svg#'+name" />
  </svg>
</template>

<script>
export default {
  props: {
    name: String,
  },
}
</script>